import { EditorPreparingEvent } from "devextreme/ui/data_grid";
import { GridType } from "../../types/types";

function onEditorPreparingHandler(e: EditorPreparingEvent<any, any>) {
  if (e.parentType === "searchPanel") {
    e.editorOptions.stylingMode = "outlined";
    e.editorOptions.placeholder = "Search in grid";
    e.editorOptions.width = "274px";
  }
}

export const basicSettings: GridType<any, any> = {
  showBorders: true,
  showColumnLines: false,
  hoverStateEnabled: true,
  allowColumnReordering: true,
  remoteOperations: true,
  columnAutoWidth: true,
  rowAlternationEnabled: true,
  columnFixing: {
    enabled: true,
  },
  scrolling: {
    mode: "standard",
    showScrollbar: "always",
    scrollByThumb: true,
    scrollByContent: true,
  },
  filterRow: {
    visible: true,
    applyFilter: "auto",
  },
  filterPanel: {
    visible: true,
  },
  headerFilter: {
    visible: true,
  },
  searchPanel: {
    visible: true,
  },
  pager: {
    visible: true,
    displayMode: "full",
    showInfo: true,
    showNavigationButtons: true,
  },
  editing: {
    useIcons: true,
  },
  columnChooser: {
    enabled: true,
    height: 430,
    mode: "select",
    position: {
      at: "right top",
      offset: {
        x: -430,
        y: 365,
      },
    },
  },
  remoteOperationsConfig: {
    filtering: true,
    paging: true,
    sorting: true,
    summary: true,
    grouping: true,
    groupPaging: true,
  },
  onSelectionChanged: () => {},
  onEditorPreparing: onEditorPreparingHandler,
  style: {
    height: "85dvh",
  },
};
